<template>
  <div class="router-header flex flex-wrap items-center">
    <div class="content-area__heading">
      <p class="font">{{ $t("labels.requested_classes") }}</p>
    </div>
    <div class="ml-auto md:block">
      <vs-button
        color="success"
        icon="icon-search"
        @click="data_hide = !data_hide"
        icon-pack="feather"
        >Search</vs-button
      >
    </div>
    <vx-card class="mt-4" v-show="data_hide">
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/4 w-full">
          <label class="vs-input--label">{{ $t("labels.mode") }}</label>
          <v-select
            v-validate="'required'"
            :placeholder="$t('labels.select_mode')"
            name="subcategory_type"
            v-model="mode"
            :clearable="false"
            :success="true"
            success-text="This field is valid"
            :options="categoryArray"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            class="w-full"
            label="value"
          />
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <label class="vs-input--label">{{ $t("labels.interestt") }}</label>
          <v-select
            v-validate="'required'"
            :placeholder="$t('labels.select_interest')"
            name="subcategory_type"
            v-model="interest"
            :success="true"
            :clearable="false"
            success-text="This field is valid"
            :options="interestArray"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            class="w-full"
            label="code"
          />
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <vs-input
            class="w-full"
            icon-pack="feather"
            placeholder="Email"
            icon-no-border
            label="Email"
            v-model="email"
            @keyup.delete="getAllTeacher()"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button color="success" class="mr-3 mb-2" @click="getAllTeacher()"
            >Search</vs-button
          >
          <vs-button color="danger" class="mb-2 mr-3" @click="resetForm()"
            >Reset</vs-button
          >
          <vs-button color="black" class="mb-2" @click="data_hide = !data_hide"
            >Close</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card class="mt-4">
      <vs-table :max-items="perPage" stripe :data="users">
        <template slot="thead">
          <vs-th>{{ $t("labels.email") }}</vs-th>
          <vs-th>{{ $t("labels.description") }}</vs-th>
          <vs-th>{{ $t("labels.mode") }}</vs-th>
          <vs-th>{{ $t("labels.location") }}</vs-th>
          <vs-th>{{ $t("labels.interest") }}</vs-th>
          <vs-th>{{ $t("labels.date") }}</vs-th>
          <vs-th>{{ $t("labels.start_time_utc_title") }}</vs-th>
          <vs-th>{{ $t("labels.end_time_utc_title") }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].creator_detail.email">
              {{ data[indextr].creator_detail.email }}
            </vs-td>

            <vs-td class="word-break" :data="data[indextr].description">
              {{ data[indextr].description }}
            </vs-td>

            <vs-td :data="data[indextr].mode">
              <p v-if="data[indextr].mode == 'ON'">
                {{ $t("labels.online") }}
              </p>
              <p v-if="data[indextr].mode == 'OF'">
                {{ $t("labels.ofline") }}
              </p>
            </vs-td>
            <vs-td :data="data[indextr].location">
              {{ data[indextr].location | address_format }}
            </vs-td>
            <vs-td :data="data[indextr].interest_detail.code">
              {{ data[indextr].interest_detail.code }}
            </vs-td>

            <vs-td :data="data[indextr].date">
              {{ data[indextr].date | formatDate }}
            </vs-td>
            <vs-td :data="data[indextr].start_time">
              {{ data[indextr].start_time }}
            </vs-td>
            <vs-td :data="data[indextr].end_time">
              {{ data[indextr].end_time }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <div class="float-right mt-5">
      <vs-pagination
        ref="paginationApplication"
        :total="totalPage"
        v-model="currentPage"
      ></vs-pagination>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
export default {
  components: {
    "v-select": vSelect,
  },
  data: () => ({
    value: "",
    select2: "",
    data_hide: false,
    users: [],
    id: "",
    email: "",
    classes: "",
    changeID: null,
    deleteID: null,
    page: 1,
    perPage: 10,
    totalPage: 0,
    currentPage: 1,
    interest: null,
    mode: null,
    interest_search: "",
    mode_search: "",
    categoryArray: [
      {
        id: "ON",
        value: "Online",
      },
      {
        id: "OF",
        value: "Offline",
      },
    ],
    interestArray: null,
  }),
  watch: {
    currentPage(nv) {
      if (nv) {
        // this.$route.query.page = nv;
        this.getAllTeacher();
      }
    },
    perPage(nv) {
      if (nv) {
        this.getAllTeacher();
      }
    },
    search(nv) {
      if (!nv) {
        this.perPage = 10;
        this.currentPage = 1;
        if (this.$refs.paginationApplication) {
          this.$refs.paginationApplication.current = 1;
        }
        this.getAllTeacher();
      }
    },
  },
  methods: {
    getAllTeacher() {
      if (this.interest) {
        this.interest_search = this.interest.id;
      } else {
        this.interest_search = "";
      }
      if (this.mode) {
        this.mode_search = this.mode.id;
      } else {
        this.mode_search = "";
      }
      let input = {
        mode: this.mode_search,
        interest: this.interest_search,
        email: this.email,
        page: this.currentPage,
        perPage: this.perPage,
      };
      axios
        .post("admin/allRequests", input)
        .then((response) => {
          let data = response.data.data;
          this.users = data.requests;
          if (data.count < this.perPage) {
            this.currentPage = 1;
          }
          this.totalPage = Math.ceil(data.count / this.perPage);
        })
        .catch((e) => {
          this.showError(e);
        });
    },
    resetForm() {
      this.interest = "";
      this.email = "";
      this.mode = "";
      this.getAllTeacher();
    },
    BlockUnblock(id, status) {
      this.changeID = id;
      this.sts = status;
      let text = text;
      let title_model = title_model;
      if (status) {
        text = this.$t("strings.block_user");
        title_model = this.$t("labels.block_user");
      } else {
        text = this.$t("strings.unblock_user");
        title_model = this.$t("labels.unblock_user");
      }
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: title_model,
        text: text,
        acceptText: this.$t("labels.delete_button"),
        accept: this.acceptAlert,
      });
    },
    acceptAlert() {
      let input = {
        is_active: !this.sts,
      };
      axios
        .post("user/changeStatus/" + this.changeID, input)
        .then((response) => {
          let data = response.data;
          this.$vs.notify({
            text: data.message,
            color: "success",
            position: "top-right",
          });
          this.getAllTeacher();
          this.changeID = null;
        })
        .catch((e) => {
          this.changeID = null;
          this.showError(e);
        });
    },
    DeleteAccount(id) {
      this.deleteID = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("labels.delete_user"),
        text: this.$t("strings.delete_user"),
        acceptText: this.$t("labels.delete_button"),
        accept: this.deleteUser,
      });
    },
    deleteUser() {
      let input = {
        user_id: this.deleteID,
      };
      axios
        .post("user/deleteAccount", input)
        .then((response) => {
          let data = response.data;
          this.getAllStudents();
          this.$vs.notify({
            text: data.message,
            color: "success",
            position: "top-right",
          });

          this.deleteID = null;
        })
        .catch((e) => {
          this.deleteID = null;
          this.showError(e);
        });
    },
    getAllInterests() {
      axios
        .post("user/getAllInterest")
        .then((response) => {
          let data = response.data.data;
          console.log(data);
          this.interestArray = data;
        })
        .catch((e) => {
          this.showError(e);
        });
    },
  },
  mounted() {
    this.getAllTeacher();
    this.getAllInterests();
  },
};
</script>

<style lang="scss" scoped>
</style>